import * as React from 'react';
import styled from 'styled-components';
import { JRCSkeletonLine } from '../JRCSkeleton/JRCSkeletonLine';

const SkeletonRowContainer = styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: flex-start;
    align-items: flex-start;
    flex: 1 100%;
    overflow: hidden;
    border-radius: 6px;
    border: 1px solid ${(props) => props.theme.color.grey1};
    margin: 8px 32px;
    padding: 22px;
    cursor: pointer;
    &:hover {
        border: 1px solid ${(props) => props.theme.color.lavender};
        background: ${(props) => props.theme.color.grey0};
    }
`;

const SkeletonLines = styled.div`
    display: flex;
    flex: 4;
    flex-direction: column;
    flex-wrap: wrap;
    justify-content: flex-start;
    align-items: flex-start;
    margin: 2px 8px;
`;

const SkeletonPart = () => (
    <SkeletonRowContainer data-theme="skeleton">
        <SkeletonLines>
            <JRCSkeletonLine width="50%" />
            <JRCSkeletonLine width="30%" />
            <br />
            <JRCSkeletonLine width="50%" />
            <JRCSkeletonLine width="30%" />
            <JRCSkeletonLine width="10%" />
        </SkeletonLines>
    </SkeletonRowContainer>
);

export const Skeleton = () => (
    <>
        <SkeletonPart />
        <SkeletonPart />
        <SkeletonPart />
        <SkeletonPart />
    </>
);
